// extracted by mini-css-extract-plugin
module.exports = {"tx_green":"FooterFixed_tx_green__2p9V2","content_footer_fix":"FooterFixed_content_footer_fix__9qolK","col_mb":"FooterFixed_col_mb__1hJv8"};